var map = {
	"./agathos/about_us_gallery/image_1.jpg": 33532,
	"./agathos/about_us_gallery/image_2.jpeg": 96152,
	"./agathos/about_us_gallery/image_3.jpg": 44459,
	"./agathos/about_us_gallery/image_4.JPG": 68076,
	"./agathos/about_us_gallery/image_5.JPG": 26928,
	"./agathos/app_logo.svg": 99776,
	"./agathos/app_logo_white.svg": 44134,
	"./agathos/error.svg": 33433,
	"./agathos/favicon.ico": 28282,
	"./agathos/hero_img_landing.png": 64153,
	"./agathos/hero_img_landing.webp": 60915,
	"./agathos/hero_img_landing_responsive.png": 98599,
	"./agathos/hero_img_landing_responsive.webp": 87271,
	"./agathos/ic_password_check.svg": 51708,
	"./agathos/ic_play.svg": 41097,
	"./agathos/img_background_landing.svg": 50817,
	"./agathos/img_login.svg": 19885,
	"./agathos/img_mobile_section.png": 23547,
	"./agathos/img_mobile_section.webp": 5099,
	"./agathos/img_recover_password.svg": 22574,
	"./agathos/no_data.svg": 93594,
	"./antorcha/about_us_gallery/image_1.jpg": 14443,
	"./antorcha/about_us_gallery/image_2.jpeg": 78065,
	"./antorcha/about_us_gallery/image_3.jpg": 55507,
	"./antorcha/about_us_gallery/image_4.JPG": 91038,
	"./antorcha/about_us_gallery/image_5.JPG": 75726,
	"./antorcha/app_logo.png": 12882,
	"./antorcha/app_logo_white.png": 1422,
	"./antorcha/error.svg": 74817,
	"./antorcha/favicon.png": 36083,
	"./antorcha/hero_img_landing.png": 30435,
	"./antorcha/hero_img_landing.webp": 91508,
	"./antorcha/hero_img_landing_responsive.png": 69424,
	"./antorcha/hero_img_landing_responsive.webp": 42499,
	"./antorcha/ic_password_check.svg": 42972,
	"./antorcha/ic_play.svg": 30287,
	"./antorcha/img_background_landing.svg": 28495,
	"./antorcha/img_login.svg": 83711,
	"./antorcha/img_mobile_section.png": 75817,
	"./antorcha/img_mobile_section.webp": 10018,
	"./antorcha/img_recover_password.svg": 10728,
	"./antorcha/no_data.svg": 70732,
	"./blaze/app_logo.svg": 47521,
	"./blaze/app_logo_white.svg": 69968,
	"./blaze/error.svg": 38185,
	"./blaze/favicon.ico": 32887,
	"./blaze/hero_img_landing.png": 3157,
	"./blaze/hero_img_landing.webp": 23732,
	"./blaze/hero_img_landing_responsive.png": 43837,
	"./blaze/hero_img_landing_responsive.webp": 79027,
	"./blaze/ic_password_check.svg": 96294,
	"./blaze/ic_play.svg": 46672,
	"./blaze/img_background_landing.svg": 60771,
	"./blaze/img_login.svg": 58551,
	"./blaze/img_mobile_section.png": 5841,
	"./blaze/img_mobile_section.webp": 54919,
	"./blaze/img_recover_password.svg": 2906,
	"./blaze/no_data.svg": 69994,
	"./ic_app_store.svg": 4273,
	"./ic_arrow_down.svg": 3376,
	"./ic_arrow_left_black.svg": 86282,
	"./ic_arrow_right_black.svg": 4710,
	"./ic_check.svg": 40591,
	"./ic_close.svg": 37424,
	"./ic_downloadable.svg": 89638,
	"./ic_google_play.svg": 62462,
	"./ic_lessons.svg": 43870,
	"./ic_link.svg": 76925,
	"./ic_mail.svg": 11519,
	"./ic_pdf.svg": 11578,
	"./ic_quiz.svg": 95590,
	"./ic_search_black.svg": 24184,
	"./ic_search_white.svg": 81927,
	"./ic_star.svg": 76446,
	"./ic_time.svg": 40394,
	"./no_image.svg": 15791,
	"./teleios/app_logo.svg": 74735,
	"./teleios/app_logo_white.svg": 17413,
	"./teleios/error.svg": 43410,
	"./teleios/favicon.ico": 94995,
	"./teleios/hero_img_landing.png": 29268,
	"./teleios/hero_img_landing.webp": 27906,
	"./teleios/hero_img_landing_responsive.png": 37297,
	"./teleios/hero_img_landing_responsive.webp": 24915,
	"./teleios/ic_password_check.svg": 77244,
	"./teleios/ic_play.svg": 95693,
	"./teleios/img_background_landing.svg": 93259,
	"./teleios/img_login.svg": 1825,
	"./teleios/img_mobile_section.png": 85440,
	"./teleios/img_mobile_section.webp": 30076,
	"./teleios/img_recover_password.svg": 93422,
	"./teleios/no_data.svg": 70817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68159;